module.exports = __webpack_public_path__ + "static/media/logo_escribli_circle2.fc01282a.svg";